import Cookies from "js-cookie";

/*
 * KB ONLINE INTEGRATION
 */
/**
 * Handle cta
 *
 * @param container {HTMLElement} container element
 */

const Cta = (container: HTMLElement) => {
  const loader = container.querySelector(".js-cta-loader");
  const generalConfig = window.WIDGETS_CONFIG?.general as General;

  const failed = () => {
    const error: HTMLElement = document.querySelector(".js-cta-error");
    const alertText = error?.dataset?.cta_error;
    // eslint-disable-next-line no-alert
    alert(alertText);
    loader?.classList.remove("is-active");
    document.removeEventListener("kbo:load-failed", failed);
  };

  const handleCtaClick = (event: MouseEvent) => {
    const useCase = container.dataset.ctaUsecase;
    const addSessionId = container.dataset.ctaAddsessionid;

    if (useCase === "app") {
      const sessionIdName = generalConfig.meiroSessionId;
      const meiroUrlParam = generalConfig.meiroUrlParam == null || generalConfig.meiroUrlParam.length === 0 ? sessionIdName : generalConfig.meiroUrlParam;
      if (sessionIdName) {
        const meiroCookie = Cookies.get(sessionIdName);
        const clickedLink = event.currentTarget as HTMLAnchorElement;

        if (clickedLink && meiroCookie && addSessionId === "true") {
          event.preventDefault();
          const redirectUrl = clickedLink.href;
          window.location.href = `${clickedLink.href}${redirectUrl.indexOf("?") > 0 ? `&` : `?`
            }${meiroUrlParam}=${meiroCookie}`;
        }
        else if (clickedLink && addSessionId === "false") {
          event.preventDefault();
          window.location.href = clickedLink.href;
        }
      }
      return;
    }

    if (container.classList.contains("btn")) {
      container.classList.add("btn--loading", "w-[190px]", "h-[50px]");
      // eslint-disable-next-line no-param-reassign
      container.innerText = "";

      // Set a timeout to remove the loader classes and restore the button text after 5 seconds
      setTimeout(() => {
        container.classList.remove("btn--loading", "w-[190px]", "h-[50px]");
        // eslint-disable-next-line no-param-reassign
        container.innerText = "Sjednat schůzku"; // Replace with the original button text
      }, 25000);
    }

    event.preventDefault();

    const lang = container.dataset.ctaLanguage;
    const productCode = container.dataset.ctaProductcode;
    const productId = Number(container.dataset.ctaProductid);
    const name = container.dataset.ctaProductname;
    const source = container.dataset.ctaSource;
    const channelId = container.dataset.ctaChanneid;
    const objectCode = container.dataset.ctaObjectcode;
    const bankAdvisorGroupId = container.dataset.ctaBankadvisorgroupid;
    const branchId = container.dataset.ctaBranchid;
    const BranchName = container.dataset.ctaBranchdetail;

    // load kbo app
    document.dispatchEvent(
      new CustomEvent("kbo:load", {
        detail: {
          lang,
          useCase,
          data: {
            productCode,
            productId,
            product: {
              name,
              detail: "",
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              clickAction: () => { },
            },
            source,
            visitorId: "a087bc9a48c60203",
            bankAdvisorGroupId, // 1-> IND produkty, 2 -> hypoteka, 3,4 -> SB produkty
            channelId,
            objectCode,
            fromBranch: {
              id: branchId,
              name: BranchName,
            },
          },
        },
      })
    );

    if (!window.kboLoaded) {
      const error: HTMLElement = document.querySelector(".js-cta-error");
      const alertText = error.dataset.cta_error;
      // eslint-disable-next-line no-alert
      alert(alertText);
    } else {
      loader?.classList.add("is-active");
    }

    document.addEventListener("kbo:load-failed", failed);
  };

  container.addEventListener("click", handleCtaClick);

  // when app loaded -> hide loader
  document.addEventListener("kbo:loaded", () => {
    setTimeout(() => {
      loader?.classList.remove("is-active");

      if (container.classList.contains("btn")) {
        container.classList.remove("btn--loading", "w-[190px]", "h-[50px]");
        // eslint-disable-next-line no-param-reassign
        container.innerText = "Sjednat schůzku";
      }
    }, 1);
  });
};

export default Cta;
